<div class="w-full flex flex-col items-center bg-white pb-10">
  <!-- Carrusel con Swiper -->
  <swiper-container
    style="
      --swiper-navigation-color: #fff;
      --swiper-pagination-color: #fff;
      --swiper-pagination-bullet-size: 20px; /* antes 14px */
      --swiper-pagination-bullet-inactive-color: #ffffff80;
      --swiper-pagination-bullet-inactive-opacity: 1;
      --swiper-pagination-bullet-margin: 10px; /* antes 6px */
    "
    class="w-full max-w-8xl h-56 sm:h-64 md:h-72 lg:h-80 xl:h-96"
    zoom="true"
    navigation="true"
    pagination="true"
    pagination-clickable="true"
    autoplay="true"
    autoplay-delay="5000"
  >
    <swiper-slide *ngFor="let img of images">
      <img
        [src]="img"
        alt="slide"
        class="w-full h-full object-cover object-center md:object-[center_-260px] xl:object-[center_-390px] 2xl:object-[center_-520px]"
      />
    </swiper-slide>
  </swiper-container>

  <!-- Cuadro de accesos -->
  <div class="grid grid-cols-1 lg:grid-cols-4 -mt-8 z-10">
    <!-- <div class="grid grid-cols-2 sm:grid-cols-4 -mt-8 z-10"> -->
    <button
      (click)="goPortalPaciente()"
      class="cursor-pointer group bg-[var(--color-primary)] text-white px-5 py-3 flex flex-row items-center justify-start md:justify-center shadow-sm hover:shadow-lg transition-all duration-300 py-4 lg:py-10 lg:px-10 rounded-2xl min-w-[250px] min-h-[80px]"
    >
      <svg
        class="shrink-0 transition-transform duration-300 ease-out group-hover:scale-110"
        width="33"
        height="48"
        viewBox="0 0 51 67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.1145 0H3.72104C1.67027 0 0 1.6678 0 3.71857V52.6431C0 54.6939 1.6678 56.3641 3.72104 56.3641H16.6014C17.2413 56.3641 17.7602 55.8453 17.7602 55.2053C17.7602 54.5654 17.2413 54.0465 16.6014 54.0465H3.72104C2.94768 54.0465 2.31762 53.4164 2.31762 52.6431V44.0101H11.9686C12.6085 44.0101 13.1274 43.4912 13.1274 42.8513C13.1274 42.2113 12.6085 41.6925 11.9686 41.6925H2.31762V14.6667H35.1325C35.2684 14.6667 35.3968 14.6396 35.5179 14.5951V30.4947C35.5179 31.1347 36.0368 31.6535 36.6767 31.6535C37.3167 31.6535 37.8355 31.1347 37.8355 30.4947V3.71857C37.8355 1.6678 36.1677 0 34.117 0H34.1145ZM35.1325 12.3541H2.31762V3.71857C2.31762 2.94521 2.94768 2.31515 3.72104 2.31515H34.1145C34.8878 2.31515 35.5179 2.94521 35.5179 3.71857V12.4232C35.3968 12.3812 35.2684 12.3516 35.1325 12.3516V12.3541Z"
          fill="white"
        />
        <path
          d="M24.3227 8.49218H13.5129C12.8729 8.49218 12.3541 7.97331 12.3541 7.33337C12.3541 6.69343 12.8729 6.17456 13.5129 6.17456H24.3227C24.9626 6.17456 25.4815 6.69343 25.4815 7.33337C25.4815 7.97331 24.9626 8.49218 24.3227 8.49218Z"
          fill="white"
        />
        <path
          d="M49.8412 58.6817H47.6348C48.2747 56.6631 48.6429 54.1552 48.6429 52.4306V38.9844C48.6429 36.7582 47.0863 34.8557 45.0207 34.5567C43.889 34.3887 42.75 34.6852 41.8506 35.3598C41.2107 34.2454 40.126 33.4399 38.8436 33.2546C37.7095 33.0891 36.5631 33.3856 35.6612 34.0651C35.0213 32.9606 33.9391 32.165 32.6666 31.9822C31.7771 31.8512 30.8876 32.0044 30.1093 32.4022V21.8864C30.1093 19.6602 28.5527 17.7577 26.4871 17.4587C25.2591 17.2808 24.0138 17.6416 23.0823 18.4495C22.1483 19.2575 21.6146 20.4262 21.6146 21.6591V36.1381C18.1308 36.6149 15.4376 39.6071 15.4376 43.2219V52.102C15.4376 53.9477 15.7069 56.5321 16.4111 58.6817H14.8273C14.1874 58.6817 13.6685 59.2006 13.6685 59.8406V65.0737C13.6685 65.7137 14.1874 66.2325 14.8273 66.2325C15.4673 66.2325 15.9861 65.7137 15.9861 65.0737V60.9994H18.1209C18.1209 60.9994 18.1357 60.9994 18.1432 60.9994C18.1506 60.9994 18.1605 60.9994 18.1679 60.9994H45.9126C45.9126 60.9994 45.9299 60.9994 45.9398 60.9994C45.9472 60.9994 45.9546 60.9994 45.962 60.9994H48.6824V65.0737C48.6824 65.7137 49.2013 66.2325 49.8412 66.2325C50.4811 66.2325 51 65.7137 51 65.0737V59.8406C51 59.2006 50.4811 58.6817 49.8412 58.6817ZM17.7602 52.102V43.2219C17.7602 40.8894 19.4206 38.9375 21.6196 38.4853V45.9398C21.6196 46.5797 22.1385 47.0986 22.7784 47.0986C23.4183 47.0986 23.9372 46.5797 23.9372 45.9398V21.6591C23.9372 21.0982 24.1818 20.567 24.6043 20.1989C25.0343 19.8258 25.5902 19.6676 26.1609 19.7492C27.0776 19.8826 27.7966 20.819 27.7966 21.884V36.1801C27.7966 36.82 28.3155 37.3389 28.9554 37.3389C29.5954 37.3389 30.1142 36.82 30.1142 36.1801C30.1142 35.6192 30.3589 35.0855 30.7814 34.7198C31.2113 34.3467 31.7672 34.1886 32.338 34.2701C33.2546 34.4036 33.9736 35.34 33.9736 36.4049V37.4525C33.9736 38.0925 34.4925 38.6113 35.1325 38.6113C35.7724 38.6113 36.2913 38.0925 36.2913 37.4525C36.2913 36.8917 36.5359 36.3604 36.9584 35.9923C37.3883 35.6192 37.9418 35.4611 38.515 35.5426C39.4317 35.676 40.1507 36.6125 40.1507 37.6774V38.7522C40.1507 39.3921 40.6695 39.911 41.3095 39.911C41.9494 39.911 42.4683 39.3921 42.4683 38.7522C42.4683 38.1913 42.7129 37.6601 43.1354 37.2919C43.5653 36.9188 44.1213 36.7607 44.692 36.8422C45.6087 36.9757 46.3277 37.9121 46.3277 38.977V52.4232C46.3277 54.1503 45.878 56.8855 45.1837 58.6743H18.8819C18.1135 56.8212 17.7602 54.0613 17.7602 52.0946V52.102Z"
          fill="white"
        />
      </svg>

      <span class="font-semibold text-2xl text-start ml-4 tracking-tight">Portal Paciente</span>
    </button>

    <button
      (click)="goSolicitarTurno()"
      class="cursor-pointer group bg-[var(--color-primary-light)] text-white px-5 py-3 flex flex-row items-center justify-start md:justify-center gap-2 shadow-sm hover:shadow-lg transition-all duration-300 rounded-2xl min-w-[250px] min-h-[80px]"
    >
      <svg
        class="shrink-0 transition-transform duration-300 ease-out group-hover:scale-110"
        width="40"
        height="40"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M58.7577 6.31267H51.0425V0.745166C51.0425 0.334333 50.7053 0 50.2945 0H45.2172C44.8063 0 44.472 0.334333 44.4692 0.745166V6.31267H15.4955V0.745166C15.4955 0.334333 15.1583 0 14.7475 0H9.67017C9.25933 0 8.925 0.334333 8.92217 0.745166V12.597C8.92217 13.0078 9.25933 13.3422 9.67017 13.3422H14.7475C15.1583 13.3422 15.4927 13.0078 15.4955 12.597V8.721H44.4692V12.597C44.4692 13.0078 44.8063 13.3422 45.2172 13.3422H50.2945C50.7053 13.3422 51.0397 13.0078 51.0425 12.597V8.721H57.5592V19.856H2.40833V8.721H6.1285C6.79433 8.721 7.33267 8.18267 7.33267 7.51683C7.33267 6.851 6.79433 6.31267 6.1285 6.31267H1.20417C0.541167 6.31267 0.00283333 6.85383 0 7.51683V58.2987C0 58.9645 0.538333 59.5028 1.20417 59.5028H58.7577C59.4235 59.5028 59.9618 58.9645 59.9618 58.2987V7.51683C59.9618 6.851 59.4235 6.31267 58.7577 6.31267ZM13.991 11.849H10.4323V1.49317H13.9995L13.991 11.849ZM49.538 11.849H45.9652V1.49317H49.5465L49.538 11.849ZM2.40833 57.0945V22.2643H57.5535V57.0945H2.40833Z"
          fill="white"
        />
        <path d="M18.1333 29.5234H9.67017V36.295H18.1333V29.5234Z" fill="white" />
        <path d="M35.0596 29.5234H26.5964V36.295H35.0596V29.5234Z" fill="white" />
        <path d="M50.2945 29.5234H41.8313V36.295H50.2945V29.5234Z" fill="white" />
        <path d="M18.1333 43.0667H9.67017V49.8384H18.1333V43.0667Z" fill="white" />
        <path d="M35.0596 43.0667H26.5964V49.8384H35.0596V43.0667Z" fill="white" />
        <path d="M50.2945 43.0667H41.8313V49.8384H50.2945V43.0667Z" fill="white" />
      </svg>

      <span class="font-semibold text-2xl text-start tracking-tight leading-tight">Solicitar Turno</span>
    </button>

    <button
      (click)="goTurnosPracticas()"
      class="cursor-pointer group bg-[var(--color-success)] text-white px-5 py-3 flex flex-row items-center justify-start md:justify-center gap-2 shadow-sm hover:shadow-lg transition-all duration-300 rounded-2xl min-w-[250px] min-h-[80px]"
    >
      <svg
        class="shrink-0 transition-transform duration-300 ease-out group-hover:scale-110"
        width="39"
        height="39"
        viewBox="0 0 59 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M54.3744 16.0513H52.5693V7.51402C52.5693 3.37134 49.198 0 45.0553 0H13.53C9.38728 0 6.01594 3.37134 6.01594 7.51402V16.0513H4.20827C1.88638 16.0513 0 17.9376 0 20.2595V53.5951C0 55.917 1.889 57.806 4.20827 57.806H54.3717C56.6936 57.806 58.58 55.917 58.58 53.5951V20.2595C58.58 17.9376 56.6936 16.0513 54.3717 16.0513H54.3744ZM1.97033 25.3651V20.2595C1.97033 19.0264 2.97517 18.0216 4.20827 18.0216H6.01594V25.3651H1.97033ZM7.98627 25.3651V7.51402C7.98627 4.45752 10.4735 1.96771 13.53 1.96771H45.0553C48.1118 1.96771 50.599 4.45489 50.599 7.51402V25.3651H7.98627ZM56.6123 27.3354V53.5951C56.6123 54.8309 55.6074 55.8357 54.3717 55.8357H4.20827C2.97255 55.8357 1.97033 54.8309 1.97033 53.5951V27.3354H56.6123ZM56.6123 20.2595V25.3651H52.5667V18.0216H54.3717C55.6074 18.0216 56.6123 19.0264 56.6123 20.2595Z"
          fill="white"
        />
        <path
          d="M12.9999 18.4597H39.4932C40.2619 18.4597 40.8863 17.8353 40.8863 17.0666C40.8863 16.2979 40.2619 15.6761 39.4932 15.6761H12.9999C12.2339 15.6761 11.6068 16.3005 11.6068 17.0666C11.6068 17.8327 12.2312 18.4597 12.9999 18.4597Z"
          fill="white"
        />
        <path
          d="M45.5826 10.8906H13.0026C12.2365 10.8906 11.6095 11.515 11.6095 12.2811C11.6095 13.0472 12.2339 13.6742 13.0026 13.6742H45.5826C46.3487 13.6742 46.9732 13.0498 46.9732 12.2811C46.9732 11.5124 46.3487 10.8906 45.5826 10.8906Z"
          fill="white"
        />
        <path
          d="M45.5826 6.10779H13.0026C12.2365 6.10779 11.6095 6.73221 11.6095 7.4983C11.6095 8.2644 12.2339 8.89144 13.0026 8.89144H45.5826C46.3487 8.89144 46.9732 8.26702 46.9732 7.4983C46.9732 6.72958 46.3487 6.10779 45.5826 6.10779Z"
          fill="white"
        />
        <path
          d="M45.5826 20.4589H13.0026C12.2365 20.4589 11.6095 21.0833 11.6095 21.8494C11.6095 22.6155 12.2339 23.2426 13.0026 23.2426H45.5826C46.3487 23.2426 46.9732 22.6182 46.9732 21.8494C46.9732 21.0807 46.3487 20.4589 45.5826 20.4589Z"
          fill="white"
        />
        <path
          d="M39.8946 37.7197H33.1546V30.9796C33.1546 30.8825 33.0759 30.8038 32.9788 30.8038H25.6038C25.5068 30.8038 25.428 30.8825 25.428 30.9796V37.7197H18.688C18.5909 37.7197 18.5122 37.7984 18.5122 37.8955V45.2704C18.5122 45.3675 18.5909 45.4462 18.688 45.4462H25.428V52.1863C25.428 52.2833 25.5068 52.362 25.6038 52.362H32.9788C33.0759 52.362 33.1546 52.2833 33.1546 52.1863V45.4462H39.8946C39.9917 45.4462 40.0704 45.3675 40.0704 45.2704V37.8955C40.0704 37.7984 39.9917 37.7197 39.8946 37.7197Z"
          fill="white"
        />
      </svg>

      <span class="font-semibold text-2xl text-start tracking-tight leading-tight">Turnos Prácticas</span>
    </button>

    <button
      (click)="goConsultarTurno()"
      class="cursor-pointer group bg-[var(--color-secondary)] text-white px-5 py-3 flex flex-row items-center justify-start md:justify-center gap-2 shadow-sm hover:shadow-lg transition-all duration-300 rounded-2xl min-w-[250px] min-h-[80px]"
    >
      <svg
        class="shrink-0 transition-transform duration-300 ease-out group-hover:scale-110"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3" y="4" width="18" height="18" rx="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>

      <span class="font-semibold text-2xl text-start tracking-tight leading-tight">Mis Turnos</span>
    </button>
  </div>
</div>
